<template>
    <basic-card>
        <template slot="header">
            {{displayName}}
        </template>
        <data-table
                :configuration="paymentBatchTableConfig"
                :data="paymentBatches.filter(batch => batch.states[batch.states.length - 1].type == paymentBatchStatus)"
                :component-id="`dashboard-widget-payment-batches[${displayName}]`"
        />
    </basic-card>
</template>

<script>
    import {mapGetters} from "vuex";
    import BasicCard from "../../layout/BasicCard";
    import DataTable from "../../table/DataTable";

    export default {
        name: "PaymentBatchesWidget",
        components: {DataTable, BasicCard},
        props: {
            displayName: String,
            paymentBatchStatus: String
        },
        data() {
            return {
                paymentBatchTableConfig: {
                    columns: [
                        {
                            caption: "Name",
                            datum: d => d.displayName
                        },
                        {
                            caption: "Status",
                            datum: d => d.states[d.states.length - 1].type
                        },
                        {
                            caption: "Payments",
                            datum: d => {
                                let payments = this.paymentsByBatch(d.id);
                                if (typeof payments == 'undefined') {
                                    this.$store.dispatch("paymentBatches/loadPaymentsByBatch", {batchId: d.id})
                                } else {
                                    return payments.length;
                                }
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            ... mapGetters({
                paymentBatches: 'paymentBatches/paymentBatches',
                paymentsByBatch: "paymentBatches/paymentsByBatch"
            })
        }
    }
</script>

<style scoped>

</style>